export default __webpack_public_path__ + "static/media/aw.2974065e.svg";